"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchActions_OnHealthThresholdEventHandlerScript = void 0;
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const enums_1 = require("../../core/enums");
let DispatchActions_OnHealthThresholdEventHandlerScript = class DispatchActions_OnHealthThresholdEventHandlerScript {
    run(sequence, container, handler, event) {
        var _a, _b;
        const { value, thresholdType = "percent", actions = [], operand, moreThanOnce = 1, target = Target_1.Target.Self } = handler.args.scriptArgs;
        handler.meta.count = (_a = handler.meta.count) !== null && _a !== void 0 ? _a : 0;
        if (handler.meta.count >= moreThanOnce) {
            return;
        }
        const threshold = thresholdType === "percent" ? container.getPercentOfMaxHealth(event.subject, value)
            : value;
        const currentHp = container.getAttributeScore(event.subject, enums_1.AttributeType.Health);
        const lastHP = (_b = handler.meta.lastHP) !== null && _b !== void 0 ? _b : currentHp;
        let activated = false;
        switch (operand) {
            case "gt":
                activated = lastHP <= threshold
                    && currentHp > threshold;
                break;
            case "gte":
                activated = lastHP < threshold
                    && currentHp >= threshold;
                break;
            case "lt":
                activated = lastHP >= threshold
                    && currentHp < threshold;
                break;
            case "lte":
                activated = lastHP > threshold
                    && currentHp <= threshold;
                break;
        }
        handler.meta.lastHP = currentHp;
        if (activated) {
            container.selectLivingTargets(event.subject, target)
                .forEach(targetId => actions.forEach(action => container.dispatch(sequence, targetId, action)));
            handler.meta.count += 1;
            if (handler.meta.count >= moreThanOnce) {
                container.cancelEventHandler(handler.id);
            }
        }
    }
};
DispatchActions_OnHealthThresholdEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("DispatchActions_OnHealthThreshold")
], DispatchActions_OnHealthThresholdEventHandlerScript);
exports.DispatchActions_OnHealthThresholdEventHandlerScript = DispatchActions_OnHealthThresholdEventHandlerScript;
